import React, { useState, useEffect } from "react";
import urlGenerator from "$ustoreinternal/services/urlGenerator";
import { useNavigate } from "react-router-dom";

import { UStoreProvider } from "@ustore/core";

import Layout from "../components/layout";
import "./Terms.scss";

const Terms = (props) => {
  return (
    <Layout {...props} className="Terms">
      <div className="content">
        <div className="headline">Terms of Use--Reprints</div>
        <div className="bodyCopy">
          <p className="Terms-BodyText">
            American Chemical Society (“ACS”) of 1155 16th Street, NW,
            Washington, D.C., 20036 owns all right, title, and interest in its
            products and services (“ACS Products”). These reprint terms of use
            (“Reprint Terms of Use”) set forth the terms and conditions
            governing your purchase of ACS Products. These Reprint Terms of Use
            expressly incorporate by reference ACS’{" "}
            <a href="https://www.acs.org/terms.html">
              Terms of Use and Legal Disclosures
            </a>{" "}
            and <a href="https://www.acs.org/privacy.html">Privacy Policy</a>.
            By checking the box, you agree to be bound by these Reprint Terms of
            Use.
          </p>
          <p className="Terms-BodyText">
            <u>Allowed Uses of the ACS Article/Issue</u>
          </p>

          <ol className="Terms-List">
            <li className="Terms-List-Item">
              ACS hereby grants you a non-exclusive, non-transferable permission
              to distribute the purchased reprints of the selected journal
              article from an ACS Product under the terms and conditions of this
              Agreement.
            </li>
            <li className="Terms-List-Item">
              Except for any author rights afforded to you if you are an author
              of the ACS Article, you may distribute the ACS Article solely to
              participants as part of a presentation at a seminar, conference,
              or workshop, or other such similar activity. You must inform each
              recipient that no further reproduction, sharing, or distribution
              (to colleagues, repositories, third parties, posting on webpages
              or listservs, etc.) is allowed. For ACS Articles published under
              open access license terms, recipients are subject to the terms and
              conditions of the license identified in the ACS Article.
            </li>
            <li className="Terms-List-Item">
              For others who may desire to use the ACS Article, you may share
              only the DOI link that points back to the Version of Record for
              the ACS Article on the ACS platform.
            </li>
          </ol>

          <p className="Terms-BodyText">
            <u>Restrictions</u>
          </p>

          <ol className="Terms-List">
            <li className="Terms-List-Item">
              The following uses of the ACS Article are strictly prohibited:
              <ol className="Terms-letter-list">
                <li>
                  Copying or otherwise making the ACS Article available to
                  others (including colleagues at the same organization), except
                  as expressly allowed in these Reprint Terms of Use;
                </li>
                <li>
                  Scanning, digitizing, making digital copies of, indexing, or
                  storing the ACS Article electronically for any reason
                  including for retrieval, distribution, training of a large
                  language model, or data mining;
                </li>
                <li>
                  Modifying, adapting, creating derivative works or products of,
                  or using the ACS Article in connection with artificial
                  intelligence in any manner;
                </li>
                <li>
                  Removing or obscuring any of the following contained in the
                  ACS Article: ACS name and logo or any registered mark of ACS,
                  copyright notices, and citations;
                </li>
                <li>
                  Using the ACS Article for document delivery services and/or
                  for any fulfillment of document delivery;
                </li>
                <li>
                  Using the ACS Article in any manner to indicate endorsement or
                  approval by ACS, including for any product, service, or
                  statement.
                </li>
              </ol>
            </li>
            <li className="Terms-List-Item">
              If additional copies are needed in the form of photocopies, you
              must obtain a license to copy from the{" "}
              <a href="https://www.copyright.com/">
                Copyright Clearance Center
              </a>{" "}
              or from your Reproduction Rights Organization.
            </li>
          </ol>

          <p className="Terms-BodyText">
            <u>Order Acceptance</u>
          </p>

          <p className="Terms-BodyText">
            ACS may choose not to accept any orders in its sole discretion.
            After receiving your order, ACS will send you a confirmation email
            with your order number and details of the items ordered. Acceptance
            of Purchaser’s order and the formation of the contract of sale
            between ACS and Purchaser will not take place unless and until the
            Purchaser has received their order confirmation email. ACS reserves
            the right to cancel orders in its sole discretion and will notify
            you of cancellation.
          </p>

          <p className="Terms-BodyText">
            <u>Termination and Disclaimer</u>
          </p>

          <ol className="Terms-List">
            <li className="Terms-List-Item">
              Purchaser must immediately cease use of and destroy any copies in
              its possession (and certify destruction) upon reasonable written
              request of ACS, such as (but not limited to) where ACS has notice
              or reasonable suspicion of violation of these Reprint Terms of Use
              or of a copyright infringement claim.
            </li>
            <li className="Terms-List-Item">
              ACS MAKES NO WARRANTY OR REPRESENTATION OF ANY KIND, EXPRESS OR
              IMPLIED, REGARDING THE ACS PRODUCTS INCLUDING THEIR QUALITY,
              ORIGINALITY, SUITABILITY, SEARCHABILITY, OPERATION, PERFORMANCE,
              COMPLIANCE WITH ANY COMPUTATIONAL PROCESS, MERCHANTABILITY OR
              FITNESS FOR A PARTICULAR PURPOSE. ACS SHALL NOT BE LIABLE FOR:
              EXEMPLARY, SPECIAL, INDIRECT, INCIDENTAL, CONSEQUENTIAL OR OTHER
              DAMAGES ARISING OUT OF OR IN CONNECTION WITH THE AGREEMENT GRANTED
              HEREUNDER, THE USE OR INABILITY TO USE ANY ACS PRODUCT, ACS’S
              PERFORMANCE UNDER THIS AGREEMENT, TERMINATION OF THIS AGREEMENT BY
              ACS OR THE LOSS OF DATA, BUSINESS OR GOODWILL EVEN IF ACS IS
              ADVISED OR AWARE OF THE POSSIBILITY OF SUCH DAMAGES. IN NO EVENT
              SHALL THE TOTAL AGGREGATE LIABILITY OF ACS OUT OF ANY BREACH OR
              TERMINATION OF THIS AGREEMENT EXCEED THE TOTAL AMOUNT PAID BY
              GRANTEE FOR ACCESS TO ACS PRODUCTS FOR THE CURRENT YEAR IN WHICH
              SUCH CLAIM, LOSS OR DAMAGE OCCURRED, WHETHER IN CONTRACT, TORT OR
              OTHERWISE, INCLUDING, WITHOUT LIMITATION, DUE TO NEGLIGENCE. The
              foregoing limitations and exclusions of certain damages shall
              apply regardless of the success or effectiveness of other
              remedies. No claim may be made against ACS unless made within six
              (6) months after the event giving rise to the claim.
            </li>
          </ol>

          <p className="Terms-BodyText">
            <u>Entire Agreement</u>
          </p>

          <p className="Terms-BodyText">
            These Reprint Terms of Use and the ACS Terms of Use and Legal
            Disclosure and Privacy Policy incorporated by reference set forth
            the entire understanding and agreement between ACS and Purchaser
            with respect to the subject matter hereof.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default Terms;
